import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { PipesModule } from '@freelancer/pipes';
import { UiModule } from '@freelancer/ui';
import { FileDownloadAlertContentComponent } from './file-download-alert-content.component';
import { FileDownloadAlertComponent } from './file-download-alert.component';

@NgModule({
  imports: [UiModule, CommonModule, PipesModule],
  declarations: [FileDownloadAlertComponent, FileDownloadAlertContentComponent],
  exports: [FileDownloadAlertComponent],
  providers: [FileOpener],
})
export class FileDownloadAlertModule {}
